export const USERDETAILS = 'USERDETAILS';
export const USERLOGINNUMBER = 'USERLOGINNUMBER';
export const APPTOKEN = 'APPTOKEN';
export const LOGINTOKEN = 'LOGINTOKEN';
export const LOGOUT = 'LOGOUT';
export const VENDORDETAILS = 'VENDORDETAILS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const CUSTOMERID = 'CUSTOMERID';
export const SET_LOCATION = 'SET_LOCATION';
export const ADD_PRODUCT_TO_STORE = 'ADD_PRODUCT_TO_STORE';
export const ADDTO_CART = 'ADDTO_CART';
export const Remove_Item_FROM_CART = 'Remove_Item_FROM_CART';
export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY';
export const RESET_CART = 'RESET_CART';
export const UPDATE_CART_TOTAL = "UPDATE_CART_TOTAL";
export const SET_MODAL_PROPERTIES = "SET_MODAL_PROPERTIES";
export const GET_PRIMARY_ADDRESS = "GET_PRIMARY_ADDRESS";
export const SET_DELIVERY_MODE = "SET_DELIVERY_MODE";
export const GET_SHOP_DETAILS = "GET_SHOP_DETAILS";
export const GET_COUPON_CODE = "GET_COUPON_CODE"
export const GET_COUPON_AMOUNT = "GET_COUPON_AMOUNT"
export const GET_SITE_SETTINGS = "GET_SITE_SETTINGS"
export const SET_FINAL_PAY_AMOUNT  = "SET_FINAL_PAY_AMOUNT"
export const SET_SITE_SETTINGS_CHARGES  = "SET_SITE_SETTINGS_CHARGES"
export const SET_PLATFORM_FEES = "SET_PLATFORM_FEES"
export const SET_DELIVERY_PARTNER_FEES = "SET_DELIVERY_PARTNER_FEES"
export const SET_GST_CHARGES = "SET_GST_CHARGES"
export const SET_COUPON_AMOUNT = "SET_COUPON_AMOUNT"